<template>
  <component :is="component" />
</template>

<script>
import salePlanCompanyCheck from '../components/salePlanCompanyCheck.vue'
import salePlanCompanyEdit from '../salePlanCompany.vue'
export default {
  components: {
    salePlanCompanyCheck,
    salePlanCompanyEdit
  },
  data() {
    return {
      component: 'salePlanCompanyCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'salePlanCompanyCheck' : 'salePlanCompanyEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/check/salePlanCompanyCheck.vue